module.exports = "img/9.6104ed.webp";